// extracted by mini-css-extract-plugin
module.exports = {"searchBar":"searchBar_searchBar__1Gsqe","searchLabel":"searchBar_searchLabel__1NNRZ"};